<route>
{
  "meta": {
    "permission": [
      "sales.add_order",
      "sales.change_order"
    ]
  }
}
</route>

<template>
  <v-card id="salePk" class="mt-5 elevation-1 mx-3">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form @submit.prevent="handleSubmit(submit)">
        <i-toolbar dontSave :title="setSalePKTitle" :loading="loading">
          <v-divider class="mx-4" inset vertical></v-divider>
          <i-btn
            color="white"
            icon="icon-request"
            text
            :small="$vuetify.breakpoint.smAndDown"
            :title="$t('sale_order')"
            @click="$router.push({ name: 'sale' })"
          ></i-btn>
          <template v-slot:arrowLeft>
            <div class="salepk-arrow">
              <i-btn
                v-if="step > 1"
                color="text-dark"
                icon="fa-arrow-left"
                text
                :small="$vuetify.breakpoint.smAndDown"
                :title="$t('back')"
                @click="back"
              >
              </i-btn>
            </div>
          </template>
          <template v-slot:arrowRight>
            <div style="display: block; min-width: 64px">
              <i-btn
                text
                :small="$vuetify.breakpoint.smAndDown"
                icon="fa-arrow-right"
                :title="$t('next')"
                color="text-dark"
                v-if="showNext()"
                @click="next()"
              >
              </i-btn>
            </div>
          </template>
          <template v-slot:submit>
            <i-btn
              text
              :title="$tc('save')"
              v-if="!invoiceCreating"
              :small="$vuetify.breakpoint.smAndDown"
              icon="fa-save"
              color="text-dark"
              :loading="loading"
              @click="submit()"
            >
            </i-btn>
          </template>
        </i-toolbar>
        <v-card-text class="pa-0">
          <v-stepper style="z-index: 0" class="elevation-0" v-model="step">
            <v-stepper-header class="elevation-0">
              <v-stepper-step :step="1" edit-icon="$complete" editable>
                {{ $t('basic') }}
              </v-stepper-step>
              <v-divider
                v-if="checkPermissions.product && order.pk"
              ></v-divider>
              <v-stepper-step
                v-if="checkPermissions.product && order.pk"
                :complete="order.mainStatus !== 'draft'"
                :step="2"
              >
                {{ $t('selection', { value: $tc('product', 2) }) }}
              </v-stepper-step>
              <v-divider
                v-if="checkPermissions.quotation && order.pk"
              ></v-divider>
              <v-stepper-step
                v-if="checkPermissions.quotation && order.pk"
                edit-icon="$complete"
                :editable="order.mainStatus !== 'draft'"
                :step="3"
              >
                {{ $t('quote') }}
              </v-stepper-step>
              <v-divider
                v-if="order.mainStatus === 'delivery' && cartlist.length > 0"
              ></v-divider>
              <v-stepper-step
                v-if="order.mainStatus === 'delivery' && cartlist.length > 0"
                edit-icon="$complete"
                :editable="order.mainStatus === 'delivery'"
                :step="4"
              >
                {{ $t('assignDriver') }}
              </v-stepper-step>
              <v-divider
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.designerorder &&
                  cartlist.length > 0
                "
              ></v-divider>
              <v-stepper-step
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.designerorder &&
                  cartlist.length > 0
                "
                edit-icon="$complete"
                :editable="checkPhase.isInFinalPhase"
                :step="4"
              >
                {{ $t('designer') }}
              </v-stepper-step>
              <v-divider
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.designerorder &&
                  cartlist.length > 0
                "
              ></v-divider>
              <v-stepper-step
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.designerorder &&
                  cartlist.length > 0
                "
                edit-icon="$complete"
                :editable="checkPhase.isInFinalPhase"
                :step="5"
              >
                {{ $t('assignProduction') }}
              </v-stepper-step>
              <v-divider
                v-if="
                  order.mainStatus === 'delivery' &&
                  cartlist.length > 0 &&
                  isBalanceSufficient
                "
              ></v-divider>
              <v-stepper-step
                v-if="
                  order.mainStatus === 'delivery' &&
                  cartlist.length > 0 &&
                  isBalanceSufficient
                "
                edit-icon="$complete"
                :editable="order.mainStatus === 'delivery'"
                :step="5"
              >
                {{ $t('delivery') }}
              </v-stepper-step>

              <v-divider
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.invoices &&
                  cartlist.length > 0
                "
              ></v-divider>
              <v-stepper-step
                :step="6"
                edit-icon="$complete"
                :editable="checkPhase.isInFinalPhase"
                v-if="
                  checkPhase.isInFinalPhase &&
                  checkPermissions.invoices &&
                  cartlist.length > 0
                "
              >
                {{ $t('billing_and_payment') }}
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <!-- Paso 1: Información básica -->
              <v-stepper-content :step="1" class="pa-0">
                <v-row class="mt-0 pb-6">
                  <v-col
                    class="align-center justify-center align-self-center"
                    cols="12"
                    md="5"
                  >
                    <v-skeleton-loader
                      v-if="loading || loadingIMG"
                      type="image"
                      tile
                    ></v-skeleton-loader>
                    <i-image
                      v-else
                      v-model="imageUrl"
                      :readonly="
                        order.orderMain == 'canceled' ||
                        order.orderMain == 'finished'
                      "
                      :file.sync="order.thumbnail"
                    />
                  </v-col>
                  <v-col cols="12" md="7">
                    <v-row>
                      <!-- Concurrencia del cliente -->
                      <v-col v-if="checkPermissions.customer" cols="12 pb-3">
                        <h6>{{ $tc('concurrence') }}</h6>
                        <div class="container-v-switch pt-2">
                          <label
                            :class="permanent_customer ? '' : 'active'"
                            for="permanent_customer"
                          >
                            {{ $t('sporadic') }}
                          </label>
                          <v-switch
                            id="permanent_customer"
                            class="mt-0 pt-0"
                            color="primary"
                            name="permanent_customer"
                            :disabled="order.mainStatus !== 'draft'"
                            v-model="permanent_customer"
                            @click="sortCustomers()"
                          ></v-switch>
                          <label
                            :class="permanent_customer ? 'active' : ''"
                            for="permanent_customer"
                          >
                            {{ $t('permanent') }}
                          </label>
                        </div>
                      </v-col>

                      <!-- Cliente -->
                      <v-col
                        v-if="checkPermissions.customer"
                        cols="12"
                        :md="
                          customer != null && customer.email != undefined
                            ? 6
                            : 12
                        "
                      >
                        <dial-customer
                          container="modal"
                          @updated="addCustomer"
                          v-model="customerfield"
                        />
                        <ValidationProvider
                          vid="customer"
                          :name="$tc('customer', 1)"
                          :rules="{ required: step === 1 }"
                          v-slot="{ errors }"
                        >
                          <v-skeleton-loader
                            v-if="loading"
                            type="list-item-avatar"
                            tile
                          ></v-skeleton-loader>
                          <v-autocomplete
                            v-show="!loading"
                            class="secondary--text"
                            :append-icon="
                              customers.length > 10 ? 'fa-search' : ''
                            "
                            autocomplete="off"
                            :item-text="
                              (item) =>
                                permanent_customer
                                  ? `${item.company_name}`
                                  : `${item.first_name} ${item.last_name}`
                            "
                            item-value="pk"
                            outlined
                            :clearable="
                              order.mainStatus === 'draft' &&
                              customers.length > 10
                            "
                            :disabled="order.mainStatus !== 'draft'"
                            :error-messages="errors[0]"
                            :items="customers"
                            :label="$tc('customer', 1)"
                            :prepend-inner-icon="
                              order.mainStatus === 'draft' &&
                              checkPermissions.customerAdd &&
                              checkPermissions.level &&
                              checkPermissions.terms
                                ? 'fa-plus'
                                : ''
                            "
                            @click:prepend-inner="customerfield = true"
                            v-model="order.customer"
                          >
                            <template v-slot:item="data">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{
                                    data.item.company_name
                                      ? `${data.item.company_name} -`
                                      : ''
                                  }}
                                  {{ data.item.first_name }}
                                  {{ data.item.last_name }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                            <!-- El botón se apaga solo mientras no haya
                                 cliente elegido: sin cliente no hay a quién
                                 escribirle. -->
                            <template v-slot:append-outer>
                              <customer-chat-button
                                :customer="order.customer"
                                :order="order.pk"
                              />
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>

                      <!-- Email -->
                      <v-col
                        v-if="
                          checkPermissions.customer &&
                          order.customer != null &&
                          customer != null &&
                          customer.email != undefined
                        "
                        cols="12"
                        :md="
                          customer != null && customer.email != undefined
                            ? 6
                            : 12
                        "
                      >
                        <v-text-field
                          color="secondary"
                          outlined
                          disabled
                          :label="$tc('email', 1)"
                          v-model="customer.email"
                        />
                      </v-col>

                      <!-- Contactos? -->
                      <v-col
                        v-if="
                          checkPermissions.customer &&
                          order.customer != null &&
                          customer != null &&
                          customer.contacts != undefined
                        "
                        cols="12"
                      >
                        <v-text-field
                          color="secondary"
                          disabled
                          outlined
                          :label="$tc('contact', 1)"
                          :value="`${customer.first_name} ${customer.last_name}`"
                        />
                      </v-col>

                      <!-- Nombre del proyecto -->
                      <v-col cols="12">
                        <ValidationProvider
                          vid="order_name"
                          :name="$tc('order_name', 1)"
                          :rules="{ required: step === 1, max: '32' }"
                          v-slot="{ errors }"
                        >
                          <v-skeleton-loader
                            v-if="loading"
                            type="text"
                            tile
                          ></v-skeleton-loader>
                          <v-text-field
                            v-else
                            color="secondary"
                            outlined
                            validate-on-blur
                            :error-messages="errors[0]"
                            :label="$t('order_name')"
                            :disabled="order.mainStatus != 'draft'"
                            v-model="order.nameOrder"
                          />
                        </ValidationProvider>
                      </v-col>

                      <!-- Fecha de la orden -->
                      <v-col cols="12" md="6" lg="4">
                        <i-date-picker
                          :loading="loading"
                          v-model="order.date"
                          :label="$tc('dateOrder', 1)"
                          :disabled="order.mainStatus != 'draft'"
                          color="primary"
                          :max="new Date().toISOString().substr(0, 10)"
                        />
                      </v-col>

                      <!-- Fecha de compromiso -->
                      <v-col cols="12" md="6" lg="4">
                        <ValidationProvider
                          vid="promise_date"
                          :name="$tc('promise_date', 1)"
                          rules=""
                          v-slot="{ errors }"
                        >
                          <i-date-picker
                            :error-messages="errors[0]"
                            :loading="loading"
                            v-model="order.promise_date"
                            :label="$tc('promise_date', 1)"
                            :disabled="order.mainStatus != 'draft'"
                            color="primary"
                            :min="order.date"
                          />
                        </ValidationProvider>
                      </v-col>

                      <!-- Fecha de cierre del pedido? -->
                      <v-col
                        v-if="order.mainStatus === 'finished'"
                        cols="12"
                        md="6"
                        lg="4"
                      >
                        <v-text-field
                          outlined
                          disabled
                          prepend-icon="fa-calendar"
                          readonly
                          :label="$tc('dateDone', 1)"
                          :value="dateFormat(order.dateDone)"
                        />
                      </v-col>

                      <!-- Entrega parcial -->
                      <v-col cols="12" md="6" lg="4">
                        <v-switch
                          class="v-switch mt-2"
                          color="primary"
                          :disabled="
                            order.mainStatus != 'draft' &&
                            order.mainStatus != 'quote'
                          "
                          :label="$t('partial')"
                          v-model="order.partialDelivery"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    checkPermissions.customer &&
                    order.customer != null &&
                    customer != null &&
                    customer.address_set != undefined
                  "
                  class="mt-0 pb-3"
                >
                  <v-col
                    cols="12"
                    md="6"
                    v-for="(address, inx) in customer.address_set"
                    :key="`address-${inx}`"
                  >
                    <v-card class="elevation-1 infocard">
                      <v-card-text :class="'primary--text'">
                        <h3 class="flex-title h6 mb-4">
                          <span>
                            {{
                              address.address_type === 'SHIP'
                                ? $t('shipping_address')
                                : $t('billing_address')
                            }}
                          </span>
                          <span>
                            <v-icon
                              v-text="
                                address.address_type == 'SHIP'
                                  ? 'fa fa-shipping-fast'
                                  : 'fa fa-money-bill'
                              "
                              color="primary"
                            />
                          </span>
                        </h3>
                        <span>{{ `${address.address1}, ` }}</span>
                        <span v-show="address.address2 != ''">
                          {{ `${address.address2}, ` }}
                        </span>
                        <span>{{ `${address.city}, ` }}</span>
                        <span>{{ `${address.state}, ` }}</span>
                        <span v-show="address.zip_code != ''">
                          {{ `${address.zip_code}` }}
                        </span>
                        <span>
                          {{
                            countries[address.country] != undefined
                              ? countries[address.country]
                              : ''
                          }}
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <!-- Paso 2: Productos -->
              <v-stepper-content class="pa-0" :step="2">
                <v-row class="my-0">
                  <v-col
                    v-if="
                      checkPermissions.product &&
                      order.pk !== '' &&
                      (order.mainStatus === 'draft' ||
                        order.mainStatus === 'quote')
                    "
                    cols="12"
                    :md="showCart ? 8 : 12"
                  >
                    <cart
                      mode="cart"
                      type="sale"
                      :status-order="order.mainStatus"
                      :order="order.pk"
                      :orderName="order.nameOrder"
                      :orderImage="orderImage"
                      :customer="customer"
                      :customerTax="customer === null ? false : customer.tax"
                    />
                  </v-col>
                </v-row>
                <shop-list
                  v-if="checkPermissions.shoppingcart"
                  ref="shoplist"
                  type="sale"
                  :cartlist.sync="cartlist"
                  :subtotalOrder.sync="order.subtotal"
                  :totalOrder.sync="order.total"
                  @update:totalOrder="internalChange = true"
                  :taxOrder.sync="order.tax"
                  :orderName="order.nameOrder"
                  :orderImage="orderImage"
                  :customerTax="customer === null ? false : customer.tax"
                  :type_customer="
                    customer
                      ? customer.level_id === null
                        ? 0
                        : customer.level_id
                      : 0
                  "
                  v-model="showCart"
                  :status="order.mainStatus"
                  :order="order.pk"
                />
              </v-stepper-content>

              <!-- Paso 3: Cotización -->
              <v-stepper-content class="pa-0" :step="3">
                <quote
                  v-if="
                    checkPermissions.quotation &&
                    order.pk != '' &&
                    order.customer != null &&
                    (step === 3 || order.mainStatus !== 'draft') &&
                    customer != null &&
                    customer.address_set != undefined
                  "
                  :status.sync="order.mainStatus"
                  :cartlist.sync="cartlist"
                  :order.sync="order"
                  @done="getOrder"
                  @update:status="internalChange = true"
                  @subtotalOrder="order.subtotal = $event"
                  @totalOrder=";(order.total = $event), (internalChange = true)"
                  @taxOrder="order.tax = $event"
                  @addProd="addProducts"
                  @approved="submit(true)"
                  :customer="customer === null ? '' : customer"
                />
              </v-stepper-content>

              <!-- Paso 4: Diseñadores -->
              <v-stepper-content :step="4">
                <assign-user
                  v-if="checkPermissions.designerorder && cartlist.length > 0"
                  :items="cartlist"
                  :mode="
                    order.mainStatus === 'delivery' ? 'delivery' : 'designer'
                  "
                />
              </v-stepper-content>

              <!-- Paso 5: Entregas / Departamento de producción -->
              <v-stepper-content
                v-if="
                  order.mainStatus === 'delivery' ||
                  order.mainStatus === 'finished'
                "
                :step="5"
              >
                <delivery
                  v-if="
                    order.pk !== '' &&
                    isBalanceSufficient &&
                    cartlist.length > 0 &&
                    checkPermissions.orderproduct &&
                    checkPermissions.delivery
                  "
                  :order="order"
                  :partialDelivery="order.partialDelivery"
                  :customer="customer === null ? '' : customer"
                  :balance="balance"
                  :cartlist.sync="cartlist"
                />
              </v-stepper-content>
              <v-stepper-content v-else :step="5">
                <assign-department
                  v-if="cartlist.length > 0"
                  :suborders="cartlist"
                  mode="production"
                />
              </v-stepper-content>

              <!-- Paso 6: Cuentas por cobrar / Facturas y pagos -->
              <v-stepper-content v-if="checkPhase.isInFinalPhase" :step="6">
                <receivables
                  v-if="
                    checkPermissions.invoices &&
                    checkPhase.isInFinalPhase &&
                    step === 6
                  "
                  :order="order.pk"
                  :customerData="customer"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-actions class="salesman-info subtitle-2">
          <span class="font-weight-black pr-1">
            {{ $tc('salesman', 1) }}:
          </span>
          {{ order.name_salesman }}
        </v-card-actions>
      </form>
    </ValidationObserver>

    <!-- Modal de email -->
    <dialChangeStatus
      :orderId="parseInt(order.pk) || 0"
      ref="dialChangeStatus"
    ></dialChangeStatus>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import Cart from '@/pages/product/index.vue'
import Quote from '@/components/sale/quotation.vue'
import ShopList from '@/components/product/shoplist.vue'
import DialCustomer from '@/pages/customer/_pk.vue'
import Receivables from '@/components/receivable/OrderReceivable.vue'
import AssignUser from '@/components/sale/assignItem.vue'
import AssignDepartment from '@/components/sale/assignDepartment.vue'
import Delivery from '@/components/sale/delivery.vue'
import dialChangeStatus from '@/components/email/changeStatus.vue'
import CustomerChatButton from '@/components/whatsapp/CustomerChatButton.vue'

export default {
  components: {
    Cart,
    Quote,
    ShopList,
    DialCustomer,
    Receivables,
    AssignUser,
    AssignDepartment,
    Delivery,
    dialChangeStatus,
    CustomerChatButton
  },
  data() {
    return {
      customerfield: false,
      loadingIMG: false,
      dialog: false,
      step: 1,
      invoiceCreating: false,
      menu: false,
      menu1: false,
      load: false,
      loading: false,
      isLoading: false,
      customer: null,
      countries: [],
      customers: [],
      searchCustomer: '',
      internalChange: false,
      showCart: false,
      cartlist: [],
      thumbnailFile: null,
      imageUrl: null,
      notification: true,
      orderImage: null,
      balance: 0,
      permanent_customer: false,
      order: {
        pk: '',
        nameOrder: '',
        date: '',
        code: '',
        customer: null,
        salesman: '',
        name_salesman: '',
        mainStatus: 'draft',
        tax: 0,
        subtotal: 0,
        total: 0,
        delivery: 0,
        discount: 0,
        dateDone: null,
        promise_date: null,
        partialDelivery: false,
        thumbnail: null,
        company_id: null
      }
    }
  },
  watch: {
    cartlist(val) {
      if (val.length > 0) {
        this.showCart = true
      }
    },
    'order.customer': {
      handler(val) {
        let inx = this.customers.findIndex((m) => val == m.pk)
        if (inx > -1) {
          this.customer = this.customers[inx]
          //this.getCountry()
        }
      }
    },
    'order.date': {
      handler(val) {
        if (
          this.order.promise_date !== null &&
          this.order.promise_date !== null &&
          new Date(val) > new Date(this.order.promise_date)
        ) {
          this.order.promise_date = null
        }
      }
    },
    'order.thumbnail': {
      handler(newValue) {
        // El usuario selecciona un archivo nuevo
        if (newValue instanceof File) {
          this.thumbnailFile = newValue
        }
        // El usuario limpia la imagen
        else if (newValue === '' || newValue === null) {
          this.thumbnailFile = null
          this.imageUrl = null
        }
        // URL de imagen existente desde el backend
        else if (typeof newValue === 'string') {
          this.thumbnailFile = null
        }
        // manejar otros casos si es necesario
        // else {
        //   console.warn('Valor inesperado para thumbnail:', newValue)
        // }
      },
      immediate: true
    },
    internalChange: {
      handler(val) {
        if (val) {
          this.submit()
        }
      }
    }
  },
  mounted() {
    this.getOrder(this.$route.params.code)
    if (this.order.mainStatus === 'in_process') {
      this.getBalance()
    }
  },
  methods: {
    /**
     * Obtiene la lista de productos asociados a la orden actual y la asigna a
     * `cartlist`. Si no hay productos en la orden y el estado principal de la
     * orden es "quote", muestra un mensaje de error al usuario.
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Ing. Argenis Osorio <argenisosorio10 at gmail.com>
     */
    async getCartlist() {
      // Realiza una solicitud a la API para obtener los productos de la orden actual
      const cart = await this.$api.sale.suborder.show({
        pk: this.order.pk, // ID de la orden actual
        opt: { params: { order: true } } // Parámetros adicionales para la solicitud
      })

      // Asigna los datos obtenidos a la lista de productos (cartlist)
      this.cartlist = cart.data

      /* Si no hay productos y el estado principal de la orden es "quote"
      muestra un error */
      if (this.cartlist.length == 0 && this.order.mainStatus == 'quote') {
        this.$toast.error(`${this.$tc('select_prod', 1)}`)
      }
    },
    changeRoute(item) {
      this.$router.push({
        name: 'customer-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    },
    addCustomer(evt) {
      this.customers = [evt]
      this.order.customer = evt.pk
    },
    async getCustomer() {
      this.isLoading = true
      try {
        if (this.customerToSale !== null) {
          if (this.customerToSale?.permanent_customer) {
            this.permanent_customer = this.customerToSale.permanent_customer
          }
          this.order.customer = this.customerToSale.pk
          this.customer = this.customerToSale
        }

        // Consulta
        const customers = await this.$api.customer.list({
          opt: {
            params: {
              permanent_customer: this.permanent_customer,
              company_id: this.company.pk,
              active: true
            }
          }
        })

        this.customers = customers.data.results
        this.$store.commit('sales/customerToSale', null)
      } finally {
        this.isLoading = false
      }
    },
    /**
     * Método retryWithoutThumbnail en caso de que falle la subida de la imagen
     */
    async retryWithoutThumbnail() {
      try {
        const form_data = new FormData()
        this.order.company_id = this.company.pk

        // Crear FormData excluyendo COMPLETAMENTE thumbnail
        for (const key in this.order) {
          if (this.order[key] == null || key === 'thumbnail') {
            continue
          }
          form_data.append(key, this.order[key])
        }

        let responseText = this.$tc('created', 2)
        if (this.order.pk !== '') {
          responseText = this.$tc('edited', 2)
        }

        const response =
          this.order.pk !== ''
            ? await this.$api.sale.edit({ pk: this.order.pk, form: form_data })
            : await this.$api.sale.create({ form: form_data })

        // Actualizar datos locales
        this.order = response.data
        this.imageUrl = response.data.thumbnail
        this.thumbnailFile = null

        this.$toast.success(`${this.$tc('order', 1)} ${responseText}`)
      } catch (error) {
        this.$toast.error(this.$t('save_error'))
      }
    },
    /**
     * Método para guardar el id del cliente en el $store y redirigir a
     * crear orden de venta
     *
     * @returns {void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async sortCustomers() {
      const customers = await this.$api.customer.list({
        opt: {
          params: {
            permanent_customer: this.permanent_customer,
            company_id: this.company.pk,
            active: true
          }
        }
      })
      this.customers = customers.data.results
    },
    async getCountry() {
      if (this.order.customer != null) {
        for (let i in this.customer.address_set) {
          let pk = this.customer.address_set[i].country
          if (this.countries[pk] == undefined) {
            try {
              const country = await this.$api.country.show({
                pk: pk
              })
              this.$set(this.countries, pk, country.data.name)
            } catch (error) {
              console.error(error)
            }
          }
        }
      }
    },
    back() {
      if (this.step === 2 && this.order.mainStatus !== 'draft') {
        this.getCartlist()
      }
      this.step -= this.step === 3 && this.order.mainStatus !== 'draft' ? 2 : 1
    },
    next() {
      this.notification = false
      if (this.step === 1 && this.order.mainStatus === 'draft') {
        this.step = 2
      } else {
        if (this.step === 1 && this.order.mainStatus !== 'draft') {
          this.step = 3
        } else {
          if (this.step === 2) {
            this.getCartlist()
            if (this.order.mainStatus === 'draft') {
              this.order.mainStatus = 'quote'
              this.submit()
            }
            this.step = 3
          } else {
            this.step += 1
          }
        }
      }
    },
    /**
     * Método para determinar si se puede avanzar al siguiente paso
     * en función del estado principal de la orden y el paso actual.
     *
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    showNext() {
      const { mainStatus } = this.order
      const isDraftOrQuote =
        mainStatus === 'draft' ||
        mainStatus === 'quote' ||
        mainStatus === 'sended_quote'

      if (mainStatus === 'delivery' && this.step > 4) return false
      if (mainStatus === 'in_process' && this.step === 6) return false

      if (isDraftOrQuote) {
        return this.step < 3 && (this.order.pk || this.step > 1)
      }
      return this.step < 7
    },
    addProducts() {
      this.step = 2
    },
    async getBalance() {
      await this.$api.invoice.receivable
        .byOrder({
          pk: this.order.pk
        })
        .then((res) => {
          this.balance = res.data.balance
        })
    },
    async getOrder() {
      let validation = this.codification({
        mode: 'decode',
        code: this.$route.params.pk
      })
      let step = this.codification({
        mode: 'decode',
        code: this.$route.params.step
      })
      this.step = step > 0 ? step : 1
      if (this.$store.getters['utils/getIsloading']) {
        this.$store.dispatch('utils/actionLoading')
      }
      if (validation !== 'create' || this.order.pk !== '') {
        if (this.order.pk !== '') {
          this.step = 3
        }
        try {
          this.loading = true
          let response = await this.$api.sale.show({
            pk: this.order.pk !== '' ? this.order.pk : validation
          })
          this.order = response.data
          // Configurar thumbnail
          if (this.order.thumbnail) {
            this.imageUrl = this.order.thumbnail
            this.thumbnailFile = null // Asegurar que no hay File residual
          } else {
            this.imageUrl = require('@/assets/default_image.png')
            this.thumbnailFile = null
          }
          if (this.order.mainStatus === 'in_process') {
            this.getBalance()
          }
        } finally {
          this.loading = false
          this.loadingIMG = false
        }
      } else {
        this.order = {
          pk: '',
          nameOrder: '',
          date: new Date().toISOString().substr(0, 10),
          code: '',
          customer: null,
          salesman: this.me.id,
          name_salesman: `${this.me.last_name} ${this.me.first_name[0]}.`,
          mainStatus: 'draft',
          tax: 0,
          subtotal: 0,
          total: 0,
          delivery: 0,
          discount: 0,
          dateDone: null,
          partialDelivery: false,
          promise_date: null,
          thumbnail: null,
          company_id: null
        }
        this.imageUrl = require('@/assets/default_image.png')
        this.thumbnailFile = null
      }

      if (this.order.customer != null) {
        try {
          let customer = await this.$api.customer.show({
            pk: this.order.customer
          })
          this.customers = [customer.data]
          this.customer = customer.data
          this.permanent_customer = this.customer.permanent_customer
          //this.getCountry()
        } catch (err) {
          this.order.customer = null
          this.customer = null
        }
      } else {
        this.getCustomer()
      }
    },
    async submit(justSave = false) {
      this.$refs.form.validate().then(async (success) => {
        if (success || justSave) {
          this.load = true

          try {
            const formData = new FormData()
            this.order.company_id = this.company.pk

            for (const key in this.order) {
              if (this.order[key] == null || key === 'thumbnail') {
                continue
              }
              formData.append(key, this.order[key])
            }

            if (this.thumbnailFile instanceof File) {
              formData.append('thumbnail', this.thumbnailFile)
            }

            let response
            let responseText = this.$tc('created', 2)

            if (this.order.pk !== '') {
              response = await this.$api.sale.edit({
                pk: this.order.pk,
                form: formData
              })

              this.order = response.data
              this.imageUrl = response.data.thumbnail
              this.thumbnailFile = null
              responseText = this.$tc('edited', 2)
            } else {
              response = await this.$api.sale.create({
                form: formData
              })

              if (!this.order.pk) {
                this.order = response.data
                this.step = 2
              }

              this.imageUrl = response.data.thumbnail
              this.thumbnailFile = null
              this.getCartlist()
              this.$emit('done')
            }

            if (this.notification) {
              this.$toast.success(`${this.$tc('order', 1)} ${responseText}`)
            }
          } catch (error) {
            const thumbnailError = error.response?.data?.thumbnail
            if (thumbnailError) {
              const errorMsg = Array.isArray(thumbnailError)
                ? thumbnailError[0]
                : thumbnailError

              if (
                errorMsg.includes('no era un archivo') ||
                errorMsg.includes('empty') ||
                errorMsg.includes('The submitted data was not a file')
              ) {
                await this.retryWithoutThumbnail()
                return
              }
            }

            this.$toast.error(this.$t('save_error'))
          } finally {
            this.notification = true
            this.load = false
            this.internalChange = false
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      me: 'session/me',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData',
      customerToSale: 'sales/getCustomerToSale'
    }),
    completed() {
      return {
        delivery:
          !this.order.partialDelivery ||
          this.cartlist.findIndex((m) => m.pending !== 0) === -1
      }
    },
    /**
     * Método para verificar si el saldo del cliente es suficiente
     * en función de su límite de crédito y el estado de la orden.
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    isBalanceSufficient() {
      const { mainStatus } = this.order
      const hasProducts =
        this.checkPermissions.orderproduct && this.checkPermissions.delivery
      const hasCustomerCredit =
        this.customer && this.customer.customercredit_set[0] !== undefined
      // Verificación del estado principal y productos
      if (
        (mainStatus === 'delivery' || mainStatus === 'finished') &&
        hasProducts
      ) {
        if (hasCustomerCredit) {
          const creditLimit = this.customer.customercredit_set[0].credit_limit
          const isBalanceSufficient = creditLimit - this.balance >= 0
          return (
            this.balance === '0.00' ||
            (this.customer.has_credit && isBalanceSufficient)
          )
        } else {
          return this.balance === '0.00'
        }
      }
      return false
    },
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        changeprice:
          this.getPermissions([`sales.view_orderchangeprice`]) || this.isAdmin,
        customer:
          this.getPermissions([`customer.view_customer`]) || this.isAdmin,
        customerAdd:
          this.getPermissions([`customer.add_customer`]) || this.isAdmin,
        delivery: this.getPermissions([`sales.view_delivery`]) || this.isAdmin,
        designerorder:
          this.getPermissions([`sales.view_assigneduser`]) || this.isAdmin,
        details:
          this.getPermissions([`product.view_productiondetails`]) ||
          this.isAdmin,
        invoices:
          this.getPermissions([`invoices.view_invoice`]) || this.isAdmin,
        imageapproval:
          this.getPermissions([`sales.view_imageapproval`]) || this.isAdmin,
        imageparameters:
          this.getPermissions([`sales.view_imageparameters`]) || this.isAdmin,
        level: this.getPermissions([`base_config.view_level`]) || this.isAdmin,
        orderproduct:
          this.getPermissions([`sales.view_orderproduct`]) || this.isAdmin,
        orderdetails:
          this.getPermissions([`sales.view_orderdetails`]) || this.isAdmin,
        orderstatus:
          this.getPermissions([`sales.view_orderstatus`]) || this.isAdmin,
        product: this.getPermissions([`product.view_product`]) || this.isAdmin,
        quotation:
          this.getPermissions([`sales.view_quotation`]) || this.isAdmin,
        suborderdate:
          this.getPermissions([`sales.view_suborderdate`]) || this.isAdmin,
        terms: this.getPermissions([`base_config.view_term`]) || this.isAdmin,
        typedate: this.getPermissions([`sales.view_typedate`]) || this.isAdmin,
        shoppingcart:
          this.getPermissions([`sales.view_orderproduct`]) &&
          this.getPermissions([`sales.view_orderstatus`]) &&
          this.getPermissions([`sales.view_orderchangeprice`]) &&
          this.getPermissions([`sales.view_imageapproval`]) &&
          this.getPermissions([`sales.view_imageparameters`]) &&
          this.getPermissions([`sales.view_typedate`]) &&
          this.getPermissions([`sales.view_suborderdate`]) &&
          this.getPermissions([`sales.view_orderdetails`]) &&
          this.getPermissions([`product.view_productiondetails`])
      }
    },
    /**
     * Método para asignarle el valor al título de la tabla
     *
     * @returns {String}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    setSalePKTitle() {
      if (this.order.pk !== '') {
        return `(${this.$t(this.order.mainStatus)})
          ${this.$tc('sale_order', 1)}
          ${this.order.code}`
      }
      return `(${this.$t(this.order.mainStatus)})
        ${this.$t('add', { value: this.$tc('sale_order', 1) })}`
    },
    /**
     * Determina si el estado de la orden pertenece al grupo de estados que se
     * le especifica.
     *
     * @returns {Boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPhase() {
      const { mainStatus } = this.order
      return {
        isInInitialPhase: mainStatus === 'draft' || mainStatus === 'quote',
        isInFinalPhase:
          mainStatus === 'in_process' ||
          mainStatus === 'production_ready' ||
          mainStatus === 'finished',
        isInDelivery: mainStatus === 'delivery' || mainStatus === 'finished'
      }
    }
  }
}
</script>
<style lang="sass">
.salepk-arrow
  // -------------------
  // Contenedor de botón
  // -------------------
  display: block
  min-width: 64px
.flex-title
  display: flex
  gap: 10px
  align-items: center
  justify-content: space-between
  text-transform: uppercase
.salesman-info
  background-color: var(--v-auxbg-base)
  border-top-left-radius: 10px
  bottom: 0
  padding: 7px 10px
  position: fixed
  right: 0
  z-index: 1
#salePk #go-to
  bottom: 45px
  right: 2vw
</style>
